<template>
  <v-textarea
    outlined
    label="Descrizione"
    counter="160"
    :class="{'length-error': length}"
    v-model="description"
  ></v-textarea>
</template>
<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'SeoDescription',
    data() {
      return {
        description: '',
        length: false
      }
    },
    computed: {
      ...mapGetters([
        'newArticle'
      ])
    },
    watch: {
      description(val) {
        if (val != null && val.length > 160) {
          this.length = true
        } else {
          this.length = false
        }

        this.$store.commit('SET_ARTICLE_DESCRIPTION', val)
      },
      newArticle: {
        handler(val) {
          this.description = val.description
        },
        deep: true
      }
    },
    created() {
      this.description = this.newArticle.description || ''
    }
  }
</script>

<style scoped>
  .length-error .v-input__control .v-text-field__details .v-counter {
    color: red;
  }
</style>